import Badge from 'react-bootstrap/Badge';
import { FormTextInput } from 'Components/Forms/FormInput.js';
import { Row, Card, Col, Form, Button } from "react-bootstrap";
import { useEffect, useReducer, useState, useRef } from "react";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import Stack from 'react-bootstrap/Stack';
import { useParams } from 'react-router-dom';
import { loadFormInfo, submitCreateOrganizationData } from 'Components/Datatable/OrgAxiosFuncs'
import { ACTIONS, formInfoReducer } from 'Containers/Private/Organization/OrganizationFormDataReducer';
import { useNavigate } from 'react-router-dom';

import 'react-phone-input-2/lib/style.css'
import { TextButton } from 'Components/Button';
import { STATUSES } from "Utils/constants";
import { useDispatch } from "react-redux"
import { setGlobalSuccessStatus } from 'Components/StatusHandling';
import 'react-phone-input-2';
import { isDateEmpty } from "Utils/utilityFunctions";

const orgId = 0;

const nameConverter = {
    "orgName": "orgName",
    "psoId": "orgId",
    "orgURL": "orgURL",
    "orgAddrLine1": "orgAddr1",
    "orgAddrLine2": "orgAddr2",
    "orgCity": "orgCity",
    "orgStateCode": "orgState",
    "orgZip": "orgZip",
    "orgZipExt": "orgZipExt",
    "orgPhone": "orgPhone",
    "orgPhoneExtension": "orgPhoneExt",
    "orgFax": "orgFax",
    "organizationStatusId": "orgStatus",
    "scpEnroll": "orgIsSCPEnrolled",
    "scpEnrollDate": "orgSCPEnrollDate",
    "testOrg": "orgIsTest",
    "listingDate": "orgListingDate",
    "firstname": "contactFirstName",
    "middlename": "contactMiddleName",
    "lastname": "contactLastName",
    "credentials": "contactCreds",
    "jobTitle": "contactJobTitle",
    "address1": "contactBusinessAddr1",
    "address2": "contactBusinessAddr2",
    "city": "contactCity",
    "state": "contactState",
    "zip": "contactZip",
    "zipext": "contactZipExt",
    "phoneForDisplay": "contactPhone",
    "phoneextn": "contactPhoneExt",
    "faxForDisplay": "contactFax",
    "emailaddress": "contactEmail",
    "confirmemailaddress": "contactConfirmEmail",
    "verifiedByUser": "contactVerify"

}

function CreateOrganization () {
    const navigate = useNavigate();
    let { oT } = useParams();
    const dispatch = useDispatch();


    function getOrgTypeText (oType) {
        switch (oType.toLowerCase()) {
            case "PSO".toLowerCase():
                return "PSO";

            case "Admin".toLowerCase():
                return "Admin";

            case "Vendor".toLowerCase():
                return "Vendor";
        }
    }
    const orgType = getOrgTypeText(oT);

    const initialState = {
        data: '',
        loading: true,
        error: null,
    };
    const [formInfo, formInfoDispatch] = useReducer(formInfoReducer, initialState);


    const formFieldDisplay = {
        orgName: {
            type: 'text',
            id: 'orgName',
            name: 'orgName',
            display: {
                label: 'Organization Name',
                description: 'Organization name maximum length: 80',
                title: "Enter an Organization's Name. Maximum number of characters allow for this field is 80 characters.",
                placeholder: null,
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgId: {
            type: 'text',
            id: 'orgId',
            name: 'orgId',
            display: {
                label: 'Organization ID',
                description: function () {
                    if (orgType.toLowerCase() == "PSO".toLowerCase()) {
                        return "Letter 'P' followed by four numeric digit (i.e, P0000)";
                    }
                    else if (orgType.toLowerCase() == "Vendor".toLowerCase()) {
                        return "Letter 'V' followed by four numeric digit (i.e, V0000)";
                    }
                    else {
                        return null;
                    }
                },
                title: "Enter Organization's ID. Example of a PSO ID: P0001 and Example of a Vendor ID: V0000",
                placeholder: null,
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgURL: {
            type: 'text',
            id: 'orgURL',
            name: 'orgURL',
            display: {
                label: 'Organization Website URL',
                description: null,
                title: "Enter Organization's website URL",
                placeholder: null,
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgAddr1: {
            type: 'text',
            id: 'orgAddr1',
            name: 'orgAddr1',
            display: {
                label: 'Address Line 1',
                description: "",
                title: "Enter Street Address",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgAddr2: {
            type: 'text',
            id: 'orgAddr2',
            name: 'orgAddr2',
            display: {
                label: 'Address Line 2',
                description: "",
                title: "Enter Street Address. This field can be used to enter extra street address",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgCity: {
            type: 'text',
            id: 'orgCity',
            name: 'orgCity',
            display: {
                label: 'City',
                description: "",
                title: "Enter City name",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgState: {
            type: 'select',
            id: 'orgState',
            name: 'orgState',
            display: {
                label: 'State',
                description: "",
                title: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgZip: {
            type: 'text',
            id: 'orgZip',
            name: 'orgZip',
            display: {
                label: 'Zip Code',
                description: "",
                title: "Enter Zip code as 5 digits.",
                placeholder: ""
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgZipExt: {
            type: 'text',
            id: 'orgZipExt',
            name: 'orgZipExt',
            display: {
                label: 'Zip Extension',
                description: "",
                title: "Enter 4 digits Zip extension if any",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgPhone: {
            type: 'tel',
            id: 'orgPhone',
            name: 'orgPhone',
            display: {
                label: 'Phone Number',
                description: "(###) ###-####",
                title: "Enter Phone Number as 10 digits. Example: (123) 456-7890",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgPhoneExt: {
            type: 'text',
            id: 'orgPhoneExt',
            name: 'orgPhoneExt',
            display: {
                label: 'Phone Number Extension',
                description: "(i.e 1234)",
                title: "Enter Phone Number extension if any. Example: 1234",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgFax: {
            type: 'tel',
            id: 'orgFax',
            name: 'orgFax',
            display: {
                label: 'Fax Number',
                description: "(###) ###-####",
                title: "Enter Fax Number as 10 digits. Example: (123) 456-7890",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        orgStatus: {
            type: 'radio',
            id: 'orgStatus',
            name: 'orgStatus',
            display: {
                label: 'Status',
                description: ""
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)

        },
        orgIsSCPEnrolled: {
            type: 'radio',
            name: 'orgIsSCPEnrolled',
            display: {
                label: 'Enrolled in SCP',
                description: ""
            },
            hideFieldOrgTypes: ["pso", "admin"],
            InputRef: useRef(null)
        },
        orgSCPEnrollDate: {
            type: 'date',
            id: 'orgSCPEnrollDate',
            name: 'orgSCPEnrollDate',
            display: {
                label: 'SCP Enrollment Date',
                description: "",
                title: "Enter two digits for Month, two digits for Date and four digits for year"
            },
            hideFieldOrgTypes: ["pso", "admin"],
            InputRef: useRef(null)
        },
        orgIsTest: {
            type: 'radio',
            name: 'orgIsTest',
            display: {
                label: 'Test Organization',
                description: ""
            },
            hideFieldOrgTypes: ["admin"],
            InputRef: useRef(null)
        },
        orgListingDate: {
            type: 'date',
            id: 'orgListingDate',
            name: 'orgListingDate',
            display: {
                label: 'Listing Date',
                description: "",
                title: "",

            },
            hideFieldOrgTypes: ["vendor", "admin"],
            InputRef: useRef(null)
        },
        contactFirstName: {
            type: 'text',
            id: 'contactFirstName',
            name: 'contactFirstName',
            display: {
                label: 'First Name',
                description: "",
                title: "Enter First Name",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactMiddleName: {
            type: 'text',
            id: 'contactMiddleName',
            name: 'contactMiddleName',
            display: {
                label: 'Middle Initial',
                description: "",
                title: "Enter Middle Initial",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactLastName: {
            type: 'text',
            id: 'contactLastName',
            name: 'contactLastName',
            display: {
                label: 'Last Name',
                description: "",
                title: "Enter Last Name",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactPrefix: {
            type: 'select',
            id: 'contactPrefix',
            name: 'contactPrefix',
            display: {
                label: 'Prefix',
                description: "",
                title: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactSuffix: {
            type: 'select',
            id: 'contactSuffix',
            name: 'contactSuffix',
            display: {
                label: 'Suffix',
                description: "",
                title: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactCreds: {
            type: 'text',
            id: 'contactCreds',
            name: 'contactCreds',
            display: {
                label: 'Credentials',
                description: "",
                title: "Enter Credentials",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactJobTitle: {
            type: 'text',
            id: 'contactJobTitle',
            name: 'contactJobTitle',
            display: {
                label: 'Job Title',
                description: "",
                title: "Enter Job Title",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactBusinessAddr1: {
            type: 'text',
            id: 'contactBusinessAddr1',
            name: 'contactBusinessAddr1',
            display: {
                label: 'Business Address Line 1',
                description: "",
                title: "Enter Business Address",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactBusinessAddr2: {
            type: 'text',
            id: 'contactBusinessAddr2',
            name: 'contactBusinessAddr2',
            display: {
                label: 'Business Address Line 2',
                description: "",
                title: "Enter Business Address. Use it to enter extra Street Address",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactCity: {
            type: 'text',
            id: 'contactCity',
            name: 'contactCity',
            display: {
                label: 'City',
                description: "",
                title: "Enter City Name",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactState: {
            type: 'select',
            id: 'contactState',
            name: 'contactState',
            display: {
                label: 'State',
                description: "",
                title: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactZip: {
            type: 'text',
            id: 'contactZip',
            name: 'contactZip',
            display: {
                label: 'Zip Code',
                description: "",
                title: "Enter 5 digits for Zip code",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactZipExt: {
            type: 'text',
            id: 'contactZipExt',
            name: 'contactZipExt',
            display: {
                label: 'Zip Extension',
                description: "",
                title: "Enter 4 digits for Zip Code Extension",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactPhone: {
            type: 'tel',
            id: 'contactPhone',
            name: 'contactPhone',
            display: {
                label: 'Phone Number',
                description: "(###) ###-####",
                title: "Enter Phone number as 10 digits. Example: (123)-456-7890",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactPhoneExt: {
            type: 'text',
            id: 'contactPhoneExt',
            name: 'contactPhoneExt',
            display: {
                label: 'Phone Ext.',
                description: "(i.e 1234)",
                title: "Enter Extension number. Example: 1234",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactFax: {
            type: 'tel',
            id: 'contactFax',
            name: 'contactFax',
            display: {
                label: 'Fax Number',
                description: "(###) ###-####",
                title: "Enter 10 digits for Fax number. Example: (123) 456-7890",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactEmail: {
            type: 'text',
            id: 'contactEmail',
            name: 'contactEmail',
            display: {
                label: 'Email Address',
                description: "",
                title: "Enter email address. Example: sampleuser@gmail.com",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactConfirmEmail: {
            type: 'text',
            id: 'contactConfirmEmail',
            name: 'contactConfirmEmail',
            display: {
                label: 'Confirm Email Address',
                description: "",
                title: "Confirm Email address by entering the same email address entered in the previous field",
                placeholder: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        },
        contactVerify: {
            type: 'checkbox',
            id: 'contactVerify',
            name: 'contactVerify',
            display: {
                label: "Verify User Information",
                description: "",
            },
            hideFieldOrgTypes: [],
            InputRef: useRef(null)
        }
    }


    var orgStatusValues = (orgStatuses) => {
        var objArr = [];

        if (orgStatuses != null) {
            for (var i = 0; i < orgStatuses.length; i++) {
                var x = orgStatuses[i];
                objArr.push({
                    id: "orgStatus_" + i,
                    label: x.description,
                    name: "orgStatus",
                    value: x.id,
                    title: "Select status as " + x.description,
                    isChecked: false,
                    onChange: handleRadioChange,
                    disabled: false
                });
            }
        }
        //console.log(objArr);
        return objArr;
    };

    var prefixListValues = (prefixList) => {
        var objArr = [];

        objArr.push({
            index: null,
            value: -1,
            title: null,
            displayValue: "Select Prefix",
            isSelected: true
        });

        for (var i = 0; i < prefixList.length; i++) {
            var x = prefixList[i];
            objArr.push({
                index: i,
                value: x.prefix,
                title: "test title",
                displayValue: x.prefix,
                isSelected: false
            });
        }

        return objArr;
    };

    var suffixListValues = (suffixList) => {
        var objArr = [];
        objArr.push({
            index: null,
            value: -1,
            title: null,
            displayValue: "Select Suffix",
            isSelected: true
        });

        for (var i = 0; i < suffixList.length; i++) {
            var x = suffixList[i];
            objArr.push({
                index: i,
                value: x.suffix,
                title: "test title",
                displayValue: x.suffix,
                isSelected: false
            });
        }

        return objArr;
    };

    var stateListValues = (stateList) => {
        var objArr = [];
        objArr.push({
            index: 0,
            value: null,
            title: null,
            displayValue: "Select State",
            isSelected: true
        });

        for (var i = 0; i < stateList.length; i++) {
            var x = stateList[i];
            objArr.push({
                index: x.regionId,
                value: x.regionId,
                title: "Select state " + x.name,
                displayValue: x.name,
                isSelected: false
            });
        }

        return objArr;
    };

    const handleInputTextChange = (e, pattern) => {
        //console.log("print out the text input change", e, e.target.attributes.id, e.target.value);
        //console.log(e);
        if (pattern != null) {
            var emptyP = /^$/g;
            if (e.target.value.match(pattern) || e.target.value.match(emptyP)) {
                formInfoDispatch({
                    type: ACTIONS.TEXT_CHANGE,
                    value: e.target.value,
                    name: e.target.name
                });
            }
        }
        else {
            formInfoDispatch({
                type: ACTIONS.TEXT_CHANGE,
                value: e.target.value,
                name: e.target.name
            });

        }
    }

    const handleInputTelChange = (value, data, event, formattedValue) => {

        //console.log("print out the tel input change", value);
        //console.log(value);
        //console.log(data);
        //console.log(event);
        //console.log(formattedValue);
        formInfoDispatch({
            type: ACTIONS.TEXT_CHANGE,
            value: formattedValue,
            name: event.target.id
        });
    }

    const handleSelectChange = (e) => {
        //console.log("print out select change", e);
        formInfoDispatch({
            type: ACTIONS.SELECT_CHANGE,
            value: e.target.value,
            name: e.target.name
        })
    }

    const handleRadioChange = (e) => {
        //console.log("print out radio change", e);
        //console.log(e.target.id);
        formInfoDispatch({
            type: ACTIONS.RADIO_CHANGE,
            value: e.target.value,
            name: e.target.name
        })
    }

    const handleCheckChange = (e) => {
        //console.log("print out checkbox change", e);
        //console.log(e.target.id);
        formInfoDispatch({
            type: ACTIONS.CHECK_CHANGE,
            name: e.target.name,
            isChecked: e.target.checked
        })
    }

    const handleInputDateChange = (e) => {
        //console.log("print out the date input change", e, e.target.attributes.id, e.target.value);
        //console.log(e);

        isDateEmpty(e);
        var val = e.target.value;
        //console.log(val);
        if (val != null) {
            var split = val.split("-");
            if (split[0].length > 4) {
                formInfoDispatch({
                    type: ACTIONS.DATE_CHANGE,
                    value: (val.substring(val.length - 7, val.length)).padStart(10, "0"),
                    name: e.target.name
                });
            }
            else {
                formInfoDispatch({
                    type: ACTIONS.DATE_CHANGE,
                    value: val,
                    name: e.target.name
                });
            }
        }
        else {
            formInfoDispatch({
                type: ACTIONS.DATE_CHANGE,
                value: '',
                name: e.target.name
            });
        }
    }

    useEffect(() => {

        loadFormInfo(orgType, ACTIONS, formInfoDispatch, handleSelectChange, handleInputTextChange, handleInputDateChange, handleRadioChange, handleCheckChange, handleInputTelChange, { stateListValues, orgStatusValues, prefixListValues, suffixListValues }, orgId);

    }, []);


    function getFieldValue (fieldName, data) {
        var values = data[fieldName];
        var dispValues = formFieldDisplay[fieldName];

        //console.log(values);
        if (formInfo.loading) {
            return '';
        }
        else {
            var type = dispValues.type;
            switch (type) {
                case "text":
                    if (values.value != null) {
                        return values.value;
                    }
                    return "";
                case "date":
                    if (values.value != null) {
                        var split = values.value.split('-');
                        //console.log(split);
                        if (split.length == 3) {
                            return split[1] + '/' + split[2] + '/' + split[0];
                        }
                        return values.value;
                    }
                    return "";
                case "select":
                    if (values != null) {
                        var arr = values.options;
                        //console.log("ARR");
                        //console.log(arr);
                        for (var x = 0; x < arr.length; x++) {
                            var val = arr[x];
                            if (val.isSelected) {
                                return val.value;
                            }
                        }
                    }
                    return null;
                case "radio":
                    if (values != null) {
                        var arr = values.radioButtons;
                        for (var x = 0; x < arr.length; x++) {
                            if (arr[x].isChecked) {
                                return arr[x].value;
                            }
                        }
                    }
                    return null;
                case "checkbox":
                    if (values != null) {
                        var arr = values.checkBoxes;
                        for (var x = 0; x < arr.length; x++) {
                            if (arr[x].isChecked) {
                                return arr[x].value;
                            }
                        }
                    }
                    return "";
                case "tel":
                    if (values.value != null) {
                        return values.value;
                    }
                    return "";
            }
        }

    }

    function addErrorMessages (fieldName, errorFieldName, data, isFirst) {
        //console.log("ADD ERROR MESSAGES");
        //console.log(d);
        var d = data.fieldErrors;
        var values = d[errorFieldName];
        //console.log(values);

        if (values != null) {
            var field = formFieldDisplay[fieldName];
            var type = field.type;
            var err = values.errorMessages;


            //console.log(field);
            if (isFirst == true) {
                (field.InputRef).current.focus();
                //console.log("ISFIRST");
            }

            switch (type) {
                case "text":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "date":
                    formInfoDispatch({
                        type: ACTIONS.DATE_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "select":
                    formInfoDispatch({
                        type: ACTIONS.SELECT_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "radio":
                    formInfoDispatch({
                        type: ACTIONS.RADIO_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "checkbox":
                    formInfoDispatch({
                        type: ACTIONS.CHECK_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
                case "tel":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        name: fieldName,
                        errors: err
                    })
                    break;
            }

        }
    }

    function clearErrorMessages (data) {
        for (const [key, value] of Object.entries(data)) {
            var t = formFieldDisplay[key];
            var fieldName = key;
            switch (t.type) {
                case "text":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "date":
                    formInfoDispatch({
                        type: ACTIONS.DATE_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "select":
                    formInfoDispatch({
                        type: ACTIONS.SELECT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "radio":
                    formInfoDispatch({
                        type: ACTIONS.RADIO_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "checkbox":
                    formInfoDispatch({
                        type: ACTIONS.CHECK_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
                case "tel":
                    formInfoDispatch({
                        type: ACTIONS.TEXT_REMOVE_ERRORS,
                        name: fieldName
                    })
                    break;
            }

        }
    }

    const handleSubmit = async () => {
        var result = await submitCreateOrganizationData(orgType, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue)
            .then((res) => {
                if (res !== null && res !== undefined) {
                    //console.log(res);
                    var statusCode = res.data.status;
                    switch (statusCode) {
                        case STATUSES.ERROR.code:
                            break;
                        case STATUSES.SUCCESS.code:

                            setGlobalSuccessStatus({
                                dispatch: dispatch,
                                popupData: {
                                    visible: true,
                                    title: "Success!",
                                    msg: "Organization has been sucessfully created.",
                                    showContactHelp: false
                                },
                                redirect: {
                                    redirect: true,
                                    redirectFirst: true,
                                    path: "/manage/organization",
                                    data: { orgType: orgType }
                                }

                            });
                            break;

                    }
                }
                //console.log(res);
            })
    };

    var dispErrors = (fieldName) => {
        var data = formInfo.data[fieldName];
        var dispData = formFieldDisplay[fieldName];
        return (
            <div>
                {data.validation.errors.length > 0 ? data.validation.errors.map((errorText, index) =>
                    <Stack key={dispData.name + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                        <div>{errorText}</div>
                    </Stack>

                ) : null}
            </div>
        );
    }

    var dispLabel = (fieldName, isHidden, getColLabelSizes, alignment, multi) => {
        var data = formInfo.data[fieldName];
        var dispData = formFieldDisplay[fieldName];

        if (alignment == Row) {
            if (multi == true) {
                return (
                    <Col hidden={isHidden}
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        <legend>
                            {<span className="me-2">{dispData.display.label}</span>}
                            {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                        </legend>
                    </Col>
                );
            }
            else {
                return (
                    <Form.Label visuallyHidden={isHidden} column
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        {<span className="me-2">{dispData.display.label}</span>}
                        {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                    </Form.Label>
                );
            }
        }
        else {
            if (multi == true) {
                return (
                    <Row hidden={isHidden}
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        <legend>
                            {dispData.display.label}
                            {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                        </legend>
                    </Row>
                );
            }
            else {
                return (
                    <Form.Label visuallyHidden={isHidden}
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        {dispData.display.label}
                        {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                    </Form.Label>
                );
            }

        }

    };

    const [phoneTestNum, setPhoneTestNum] = useState("");
    const handlePhoneChange = (e) => {
        //console.log("PHONE CHANGE", e);
        setPhoneTestNum(e);
    }

    const buttonStyle = {
        display: 'none',
        color: '#fff',
        backgroundColor: 'blue',
        fontWeight: 'bold',
    };

    const inputStyle = {
        //fontFamily: "Source Sans Pro", "helvetica", "sans-serif",

        color: 'black',

    };

    const handleCancel = async () => {
        navigate(
            "/manage/organization",
            { state: { orgType: orgType } }
        );
        
    };


    return (
        <Row >
            {
                formInfo.loading ?
                    null
                    :
                    <Row >
                        <Col xl={11} lg={11} md={11} sm={12}>
                            <Card className="p-4" >
                                <Card.Body className="text-start">

                                    <Row>
                                        <h1 id="mainContent" className="header1 text-start mb-3 blue bold">{"Create a New " + (orgType == "Admin" ? '' : orgType) + " Organization"}</h1>
                                        <p>To create a new organization, enter the required information below. </p>
                                    </Row>
                                    <Row>

                                        <Form>

                                            <h2>Organization Information</h2>


                                            <FormTextInput orgType={orgType} fieldName="orgName" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={80}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgId" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={5}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgURL" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={256}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgAddr1" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgAddr2" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgCity" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgState" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgZip" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={5}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgZipExt" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={4}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgPhone" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgPhoneExt" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='5' minLength='1'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgFax" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgStatus" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            {/*<FormTextInput orgType={orgType} fieldName="orgIsSCPEnrolled" hideLabel={false} horizontalForm={{is: true, labelCols: {lg:3, md:4}, inputCols: {lg:5}}} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                        <FormTextInput orgType={orgType} fieldName="orgSCPEnrollDate" hideLabel={false} horizontalForm={{is: true, labelCols: {lg:3, md:4}, inputCols: {lg:5}}} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='10'></FormTextInput>
                                        */}
                                            <FormTextInput orgType={orgType} fieldName="orgIsTest" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="orgListingDate" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='10'></FormTextInput>


                                            {orgType == "Vendor" ? <h2>Vendor Certified Contact Information</h2> : null}
                                            {orgType == "PSO" ? <h2>AHRQ Certified Contact Information</h2> : null}


                                            <FormTextInput orgType={orgType} fieldName="contactFirstName" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='75'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactMiddleName" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='75'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactLastName" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='75'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactPrefix" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactSuffix" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactCreds" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='4000'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactJobTitle" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='100'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactBusinessAddr1" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='75'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactBusinessAddr2" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='75'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactCity" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='75'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactState" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactZip" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='5'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactZipExt" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='4'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactPhone" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactPhoneExt" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength='5' minLength='1'></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactFax" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactEmail" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                                            <FormTextInput orgType={orgType} fieldName="contactConfirmEmail" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>

                                            <h2>Verify User Information</h2>

                                            <FormTextInput orgType={orgType} fieldName="contactVerify" hideLabel={true} horizontalForm={{ is: true, labelCols: { lg: 8, md: 4 }, inputCols: { lg: 8 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>

                                            <Stack className="pt-3" direction="horizontal" gap={3}>
                                                {/* Submit Button */}
                                                <TextButton
                                                    variant="normal"
                                                    onClick={handleSubmit}
                                                    content={"Submit"}
                                                >
                                                </TextButton>

                                                {/* Cancel Button */}
                                                <TextButton
                                                    variant="outline"
                                                    onClick={handleCancel}
                                                    content={"Cancel"}
                                                >
                                                </TextButton>
                                            </Stack>
                                        </Form>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
            }
            {}
        </Row>
    );
}

export default CreateOrganization;